module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "r-container",
    class: {
      'is-loading': _vm.isLoading
    }
  }, [(_vm.isLoading) ? _c('relatorio-loading') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "content-transition relatorio-print",
    attrs: {
      "id": "container-printer"
    }
  }, [_c('div', {
    staticClass: "hidden-print"
  }, [_c('div', {
    staticClass: "text-center m-t m-b-n"
  }, [_c('h3', {
    staticClass: "btn m-t-none",
    on: {
      "click": function($event) {
        _vm.showFiltros = !_vm.showFiltros
      }
    }
  }, [_c('span', {
    staticClass: "btn btn-default btn-xs m-r-xs"
  }, [_vm._v(_vm._s(!_vm.showFiltros ? '+' : '-'))]), _vm._v("Filtros")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFiltros),
      expression: "showFiltros"
    }],
    staticClass: "r-table"
  }, [_c('div', {
    staticClass: "r-table-content"
  }, [_c('div', {
    staticClass: "m-t"
  }, [_c('div', {
    staticClass: "m-b"
  }, [_c('div', [_vm._v("Tipo de Venda:")]), _vm._v(" "), _c('u-button-group', {
    attrs: {
      "options": _vm.tiposLeilao
    },
    model: {
      value: (_vm.filtro.tipo),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "tipo", $$v)
      },
      expression: "filtro.tipo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_c('div', [_vm._v("Situação:")]), _vm._v(" "), _c('u-button-group', {
    attrs: {
      "multiSelect": true,
      "options": _vm.situacaoLote
    },
    model: {
      value: (_vm.filtro.situacao),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "situacao", $$v)
      },
      expression: "filtro.situacao"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_vm._v("\n                Resultados: " + _vm._s(_vm.filteredData && _vm.filteredData.length) + "\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-print"
  }, [_c('h2', {
    staticClass: "text-center text-uppercase font-bold m-b-none"
  }, [_vm._v("Relatório de Lances")]), _vm._v(" "), _c('h4', {
    staticClass: "text-center text-uppercase"
  }, [_vm._v("Leilão Realizado " + _vm._s(_vm.moment(_vm.leilao.dataAbertura.date).format('LLLL')))])]), _vm._v(" "), _vm._l((_vm.filteredData), function(lote, key) {
    return _c('div', {
      staticClass: "printer-page pos-rlt"
    }, [_c('div', {
      staticClass: "visible-print"
    }, [_c('h2', {
      staticClass: "text-center text-uppercase font-bold m-b-none"
    }, [_vm._v("Relatório de Lances")]), _vm._v(" "), _c('h4', {
      staticClass: "text-center text-uppercase"
    }, [_vm._v("Leilão Realizado " + _vm._s(_vm.moment(_vm.leilao.dataAbertura.date).format('LLLL')))])]), _vm._v(" "), _c('div', {
      staticClass: "r-table"
    }, [_c('div', {
      staticClass: "r-table-header"
    }, [_c('div', {
      staticClass: "pull-left font-bold text-black"
    }, [_vm._v(_vm._s(lote.titulo))]), _vm._v(" "), _c('div', {
      staticClass: "pull-right font-bold"
    }, [_c('h3', {
      staticClass: "m-t-none"
    }, [_vm._v("Lote " + _vm._s(lote.numero))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "r-table-content"
    }, [_c('table', {
      staticClass: "w-full m-b",
      attrs: {
        "cellpadding": "0",
        "cellspacing": "0"
      }
    }, [_c('tr', [_c('td', [_vm._v("Comitente: "), _c('strong', [_vm._v(_vm._s(lote.comitente.pessoa.nome))])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("Situação: "), _c('strong', {
      class: 'text-' + _vm.Status.Status[lote.status].class
    }, [_vm._v(_vm._s(_vm.Status.Status[lote.status].titulo))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Quantidade de lances: "), _c('strong', [_vm._v(_vm._s(lote.lances ? lote.lances.length : 0))])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(lote.arremate) ? _c('span', [_vm._v("Vencedor: "), _c('strong', [_vm._v(" " + _vm._s(lote.arremate.arrematante.apelido))])]) : _vm._e()])])]), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered r-table-min"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Apelido")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', [_vm._l((lote.lances), function(lance) {
      return _c('tr', [_c('td', [_vm._v("\n                  " + _vm._s(_vm.moment(lance.data.date).format('L')) + " " + _vm._s(_vm.moment(lance.data.date).format('LTS')) + "\n                ")]), _vm._v(" "), _c('td', [_c('router-link', {
        attrs: {
          "target": "_blank",
          "to": {
            name: 'arrematante.visualizar',
            params: {
              id: lance.arrematante.id
            }
          }
        }
      }, [_vm._v(_vm._s(lance.arrematante.apelido))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(lance.arrematante.pessoa.nome))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(lance.valor)))])])
    }), _vm._v(" "), (!lote.lances || lote.lances.length === 0) ? _c('tr', [_c('td', {
      staticClass: "no-borders",
      staticStyle: {
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "3"
      }
    }, [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v("Nenhum lance")])])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
      staticClass: "p-page-numer visible-print"
    }, [_vm._v("Página " + _vm._s(key + 1) + " de " + _vm._s(_vm.filteredData && _vm.filteredData.length))])])
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6728b84e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/RelatorioLances.vue
// module id = 1747
// module chunks = 17